import { createSlice } from '@reduxjs/toolkit';
import createAsyncThunkFromFetch from 'src/store/middlewares/createAsyncThunkFromFetch';
import { deleteCmdAPI, deleteHeadsetCmdAPI, getCmdAPI, sendCmdAPI, sendHeadsetCmdAPI } from './companyCmd.api';
import { CompanyCmd } from './companyCmd.types';

const name = 'cmd';

export const sendCmd = createAsyncThunkFromFetch(`${name}/sendCmd`, sendCmdAPI);
export const fetchCmd = createAsyncThunkFromFetch(`${name}/getCmd`, getCmdAPI);
export const deleteCmd = createAsyncThunkFromFetch(`${name}/deleteCmd`, deleteCmdAPI);

export const sendHeadsetCmd = createAsyncThunkFromFetch(`${name}/sendHeadsetCmd`, sendHeadsetCmdAPI);
export const deleteHeadsetCmd = createAsyncThunkFromFetch(`${name}/deleteHeadsetCmd`, deleteHeadsetCmdAPI);

const initialState: {
  isPending: boolean;
  hasError: boolean;
  cmd: CompanyCmd;
  devices: { id: string; serial: string; hasCmd: boolean; cmd?: CompanyCmd }[];
} = {
  isPending: false,
  hasError: false,
  cmd: { payload: {} },
  devices: [],
};

const cmdSlice = createSlice({
  name,
  initialState: { ...initialState },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(sendCmd.pending, state => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(fetchCmd.pending, state => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(sendCmd.fulfilled, (state, { meta }) => {
      state.isPending = false;
      state.hasError = false;
      state.cmd = meta.arg.data;
    });
    builder.addCase(fetchCmd.fulfilled, (state, { payload }) => {
      state.isPending = false;
      state.hasError = false;
      state.cmd = payload.cmd;
      state.devices = payload.devices;
    });
    builder.addCase(deleteCmd.fulfilled, state => {
      state.isPending = false;
      state.hasError = false;
      state.cmd = { payload: {} };
      state.devices = state.devices.map(d => ({ ...d, hasCmd: false, cmd: undefined }));
    });
    builder.addCase(sendHeadsetCmd.fulfilled, (state, { meta }) => {
      state.isPending = false;
      state.hasError = false;
      state.devices = state.devices.map(d =>
        d.id === meta.arg.headsetId ? { ...d, hasCmd: true, cmd: meta.arg.data } : d
      );
    });
    builder.addCase(deleteHeadsetCmd.fulfilled, (state, { meta }) => {
      state.isPending = false;
      state.hasError = false;
      state.devices = state.devices.map(d =>
        d.id === meta.arg.headsetId ? { ...d, hasCmd: false, cmd: undefined } : d
      );
    });
    builder.addCase(sendCmd.rejected, state => {
      state.isPending = false;
      state.hasError = true;
    });
  },
});

const { reducer } = cmdSlice;

export default reducer;
